<template>
    <div class="form-group">
        <label :for="id">{{label}}</label>
        <input type="file" :id="id" class="form-control-file" accept=".zip,.mdb,.accdb" @change="updateValue($event)">
    </div>
</template>

<script>
    import { uuid } from '@/modules/helpers.js';

    export default {
        name: "FileInput",
        data: () => {
            return {
                id: uuid(),
            }
        },
        props: {
          label:{
              type: String,
          }
        },
        methods: {
            updateValue(e){
                this.$emit('fileSelected', e.target.files);
            },
            clear(){
                document.getElementById(`${this.id}`).value = '';
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
